module.exports = __webpack_public_path__ + "static/hospital.1fdcef51.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/hospital.png
// module id = 444
// module chunks = 168707334958949